(() => {
  if (window.fedsBundlesReady) return;
  window.fedsBundlesReady = true;
  let opener = null;
  const close = dialog => {
    dialog.close();
    opener?.focus();
    opener = null;
  };
  document.addEventListener('click', event => {
    const trigger = event.target.closest('[data-bundle-dialog]');
    if (trigger && !event.ctrlKey && !event.metaKey && !event.shiftKey && !event.altKey) {
      const dialog = document.getElementById(trigger.dataset.bundleDialog);
      if (!dialog || typeof dialog.showModal !== 'function') return;
      event.preventDefault();
      opener = trigger;
      dialog.showModal();
      dialog.querySelector('[data-bundle-close]')?.focus();
      return;
    }
    const closeButton = event.target.closest('[data-bundle-close]');
    if (closeButton) close(closeButton.closest('dialog'));
    if (event.target.matches('.feds-bundle-dialog')) {
      const rect = event.target.getBoundingClientRect();
      if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) close(event.target);
    }
  });
})();
